<template>
<div v-show="loadData">
    <div class="text-center m-3 p-3">
        <div> 
            <img src="@/assets/imgs/spinner.webp" class="img-fluid w-25" />     
        </div>
    </div>
</div>
<div v-show="!loadData">
    <div class="row" v-if="userMode == 1 || (userMode == 2 && connectedOk)">
        <div class="col-12">
            <div class="alert alert-info" v-if="userMode == 1">Completa la información como figura en tu Afip para poder emitir tus facturas desde Animasana.</div>
            <h5 v-if="userMode == 2 && !bill"><i class="las la-receipt text-primary"></i> Datos de Facturación</h5>
            <div class="alert alert-info" v-if="userMode == 2 && !bill">Completa la información fiscal del consultante.</div>
        </div>
        
        <div class="col-12 col-md-6" v-if="userMode == 1">
            <label>CUIT:</label>
            <div class="input-group mb-3">
                <input type="number" class="form-control form-control-lg" attr-id="docAfip" v-model="docAfip" minlength="11" maxlength="11" autocomplete="new-docAfip" @keyup.enter="getPadron()" @blur="getPadron()">
            </div>
        </div>
        <div class="col-12 col-md-6" v-if="userMode == 1">
            <label>Tipo de documento:</label>
            <div class="input-group mb-3">
                <select class="form-control form-control-lg" attr-id="docTypeAfip" v-model="docTypeAfip" autocomplete="new-docTypeAfip" disabled>
                    <option value="0" v-if="condicionIvaAfip == 0"></option>
                    <option value="80" v-if="condicionIvaAfip == 1 || condicionIvaAfip == 4 || condicionIvaAfip == 5 || condicionIvaAfip == 6  || condicionIvaAfip == 13">CUIT:</option>
                    <option value="86" v-if="condicionIvaAfip == 5">CUIL:</option>
                </select> 
            </div>
        </div>
        
        <div class="col-12" v-if="userMode == 2">
            <label>Nro. de Documento:</label>
            <div class="input-group mb-3">
                <input type="number" class="form-control form-control-lg" attr-id="docAfip" v-model="docAfip" minlength="11" maxlength="11" autocomplete="new-docAfip">
            </div>
            <button class="btn btn-primary p-3 pb-1 pt-1 mb-2 w-100" @click="getPadron()"><i class="las la-search"></i> Buscar datos fiscales</button>
            <hr>
        </div>
        <div class="col-12" v-if="userMode == 2">
            <label>Tipo de documento:</label>
            <div class="input-group mb-3">
                <select class="form-control form-control-lg" attr-id="docTypeAfip" v-model="docTypeAfip" autocomplete="new-docTypeAfip" disabled>
                    <option value="0" v-if="condicionIvaAfip == 0"></option>
                    <option value="80">CUIT:</option>
                    <option value="86" v-if="userMode == '2'">CUIL:</option>
                    <option value="96" v-if="userMode == '2' && condicionIvaAfip == 5">DNI:</option>
                </select> 
            </div>
        </div>
        <div class="col-12">
            <label>Condición frente al IVA:</label> 
            <div class="input-group mb-3">
                <select class="form-control form-control-lg" attr-id="condicionIvaAfip" v-model="condicionIvaAfip" autocomplete="new-condicionIvaAfip" @change="updateCuitType(); checkInvoiceType()" :disabled="disabledIvaType">
                    <option value="0">Seleccionar</option>
                    <option value="1">IVA Responsable Inscripto</option>
                    <option v-if="userMode == '2'" value="4">IVA Sujeto Exento</option>
                    <option v-if="userMode == '2'" value="5">Consumidor Final</option>
                    <option value="6">Responsable Monotributo</option>
                    <option v-if="userMode == '2'" value="13">Monotributista Social</option>
                </select>  
            </div>
        </div>
        <div class="col-12" v-if="userMode == 1 && connectedOk">
            <label>Apellido y Nombre / Razón Social:</label> 
            <div class="input-group mb-3">
                <input type="text" class="form-control form-control-lg" attr-id="razonSocialAfip" v-model="razonSocialAfip" autocomplete="new-razonSocialAfip">     
            </div>
        </div>
        <div class="col-12" v-if="userMode == 1 && connectedOk">
            <label>Domicilio comercial:</label> 
            <div class="input-group mb-3">
                <input type="text" class="form-control form-control-lg" attr-id="domicilioAfip" v-model="domicilioAfip" autocomplete="new-domicilioAfip">     
            </div>
        </div>

        <div class="col-12" v-if="userMode == 2">
            <label>Apellido y Nombre / Razón Social:</label> 
            <div class="input-group mb-3">
                <input type="text" class="form-control form-control-lg" attr-id="razonSocialAfip" v-model="razonSocialAfip" autocomplete="new-razonSocialAfip">     
            </div>
        </div>
        <div class="col-12" v-if="userMode == 2">
            <label>Domicilio comercial:</label> 
            <div class="input-group mb-3">
                <input type="text" class="form-control form-control-lg" attr-id="domicilioAfip" v-model="domicilioAfip" autocomplete="new-domicilioAfip">     
            </div>
        </div>
        
        <div class="col-12 col-md-6" v-if="userMode == 1 && connectedOk">
            <label>Punto de venta:</label> 
            <div class="input-group mb-3">
                <input type="number" class="form-control form-control-lg" attr-id="puntoVentaAfip" minlength="1" maxlength="2" v-model="puntoVentaAfip" autocomplete="new-puntoVentaAfip">
            </div>
        </div>
        <div class="col-12 col-md-6" v-if="userMode == 1">
            <label>Inicio de actividades:</label> 
            <div class="input-group mb-3">
                <input type="date" class="form-control form-control-lg" attr-id="fechaInicioAfip" v-model="fechaInicioAfip" autocomplete="new-fechaInicioAfip">
            </div>
        </div>
        <div class="col-12 col-md-12" v-if="userMode == 2 && bill">
            <hr class="text-blue">
            <label>Tipo de factura:</label> 
            <div class="input-group mb-3">
                <select class="form-control form-control-lg" attr-id="invoiceType" v-model="invoiceType" autocomplete="new-invoiceType" :disabled="disabledTypeFac">
                    <option value="0">Seleccionar</option>
                    <option v-if="condicionIvaProf == 1" value="1">Factura A</option>
                    <option v-if="condicionIvaProf == 1" value="6">Factura B</option>
                    <option v-if="condicionIvaProf == 6" value="11">Factura C</option>
                </select>  
            </div>
            <h5 class="text-center">Concepto</h5>
            <div class="input-group mb-3">
                <textarea type="text" class="form-control form-control-lg" attr-id="billDetails" maxlength="250" v-model="concepto" autocomplete="new-billDetails" style="height: 150px;" @keyup="formatConcept()"  @blur="formatConcept()"></textarea>
            </div>
            <h4 class="text-center text-blue"><b>Valor: ARS {{ billPrice }}</b></h4>
            <label>Enviar factura por mail a:</label> 
            <div class="input-group mb-3">
                <input type="mail" class="form-control form-control-lg" attr-id="userMail" v-model="userMailAddress" autocomplete="new-userMail">
            </div>
        </div>
        <div class="mb-3 d-grid gap-2 col-12 mx-auto mt-3">
            <button v-if="bill" class="btn btn-primary w-100" type="submit" :disabled="disabled" @click="generateBill()"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> {{textButton}}</button>
            <button v-else class="btn btn-primary w-100" type="submit" :disabled="disabled" @click="saveData()"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span> {{textButton}}</button>
            <button v-if="userMode == 1" class="btn btn-secondary w-100" type="button" @click="this.$router.go(-1)">Volver</button>
            <button v-if="bill" class="btn btn-secondary w-100" type="button" @click="closePopUp()">Cancelar</button>
        </div> 
    </div>
    <div class="row" v-else>
        <div class="col-12">      
            <h5 v-if="userMode == 2"><i class="las la-receipt text-primary"></i> Datos de Facturación</h5>
            <div class="alert alert-info" v-if="userMode == 2">Para poder facturar desde Animasana primero debes configurar el servicio de Afip. Puedes hacerlo desde <b><a class="pointer link text-primary" @click="gotoAfip()">aquí</a></b></div>
            <button v-if="bill" class="btn btn-secondary w-100 mt-3" type="button" @click="closePopUp()">Cancelar</button>
        </div>
    </div>

</div>

<div class="position-fixed bottom-0 end-0 start-0 p-3" style="z-index: 11; width: fit-content;">
    <div id="toastcontainerAfip" class="w-25">
    </div>
</div>
</template>
<script>
import axios from "axios";
import { Toast } from 'bootstrap'
export default { 
    name: "formAfipData",
    props: ['userSelected', 'userMode', 'generateKey', 'textButton', 'refContact', 'bill', 'billDetails', 'billPrice', 'bookingId', 'userMail', 'obraSocial', 'numObraSocial'],
    data(){
        return{
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            razonSocialAfip: '',
            domicilioAfip: '',
            condicionIvaAfip: 0,
            docTypeAfip: 0,
            docAfip: '',
            puntoVentaAfip: 1,
            fechaInicioAfip: '',
            disabledQuit: true,
            disabled: false,
            loading: false,
            connectedOk: false,
            disabledIvaType: false,
            concepto: this.billDetails,
            disabledTypeFac: false,
            invoiceType: 0,
            condicionIvaProf: 0,
            loadData: true,
            userMailAddress: this.userMail,
            dataReceiver: ''
        }
    },
    mounted: function () {
        if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
            this.dataReceiver = localStorage.getItem('corporativeIn');
        }else{
            this.dataReceiver = localStorage.getItem('token');
        }
        this.getData();  
        if(this.obraSocial != '' && this.numObraSocial != ''){
            this.concepto = this.concepto + ' - ( Afiliado ' + this.obraSocial + ': ' + this.numObraSocial + ' )';
        } 
    }, 
    methods:{
        updateCuitType(){
            if(this.condicionIvaAfip == 0){
                this.disabledQuit = true;
            }else{
                this.disabledQuit = false;
                this.docTypeAfip = 80;  
            }
        },
 
        async saveData(){  
            if(this.userMode  == '1'){
                if(this.razonSocialAfip == ''){
                    this.razonSocialAfip = '---'
                }
                if(this.domicilioAfip == ''){
                    this.domicilioAfip = '---'
                }
            }
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.errorText = '';
            this.loading = true;
            this.disabled = true;
            var payload = {
                action: 'update-afip-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userSelected,
                razonSocial: this.razonSocialAfip,
                domicilioFiscal: this.domicilioAfip,
                condicionIva: this.condicionIvaAfip,
                docTipo: this.docTypeAfip,
                cuit: this.docAfip,
                puntoVenta: this.puntoVentaAfip,
                fechaInicio: this.fechaInicioAfip,
                userMode: this.userMode,
                refContact: this.refContact
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.loading = false;
                this.disabled = false;
                if(result.data.status == '200'){
                    if(this.userMode == '1'){
                        this.$router.push({ name: 'link-afip'});    
                    }else{
                        this.errorText = 'Datos de facturación guardados.';
                        this.toastBg = 'bg-success';
                        this.toastColor = 'text-dark';
                        this.toastNumber++;
                        var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                        try{
                            document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                            var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                            var bsAlert = new Toast(myAlert);//inizialize it
                            bsAlert.show();//show it
                        }catch(e){

                        }	
                    }
                }else if(result.data.status == '400'){
                    if(result.data.error == 'E2'){
                        this.errorText = 'Debes ingresar el Apellido y Nombre o Razón Social.';
                        document.querySelector("[attr-id='razonSocialAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E3'){
                        this.errorText = 'El Apellido y Nombre o Razón Social no puede superar los 250 caracteres.';
                        document.querySelector("[attr-id='razonSocialAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E4'){
                        this.errorText = 'El Apellido y Nombre o Razón Social solo acepta caracteres alfanúmericos.';
                        document.querySelector("[attr-id='razonSocialAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E5'){
                        this.errorText = 'Debes ingresar el Domicilio comercial.';
                        document.querySelector("[attr-id='domicilioAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E6'){
                        this.errorText = 'El Domicilio comercial no puede superar los 250 caracteres.';
                        document.querySelector("[attr-id='domicilioAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E7'){
                        this.errorText = 'El Domicilio comercial solo acepta caracteres alfanúmericos.';
                        document.querySelector("[attr-id='domicilioAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E8'){
                        this.errorText = 'Debes seleccionar la Condición frente al IVA.';
                        document.querySelector("[attr-id='condicionIvaAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E9'){
                        this.errorText = 'Debes seleccionar el Tipo de documento.';
                        document.querySelector("[attr-id='docTypeAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E10'){
                        this.errorText = 'El Tipo de documento no puede ser CUIL con la Condición frente al IVA seleccionada.';
                        document.querySelector("[attr-id='docTypeAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E11'){
                        if(this.docTypeAfip == '80'){
                            this.errorText = 'Debes ingresar el CUIT.';
                        }else{
                            this.errorText = 'Debes ingresar el CUIL.';
                        }
                        document.querySelector("[attr-id='docAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E12'){
                        if(this.docTypeAfip == '80'){
                            this.errorText = 'El CUIT debe estar formado por 11 números sin guiones.';
                        }else{
                            this.errorText = 'El CUIL debe estar formado por 11 números sin guiones.';
                        }
                        document.querySelector("[attr-id='docAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E13'){
                        if(this.docTypeAfip == '80'){
                            this.errorText = 'El CUIT debe estar formado por 11 números sin guiones.';
                        }else{
                            this.errorText = 'El CUIL debe estar formado por 11 números sin guiones.';
                        }
                        document.querySelector("[attr-id='docAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E14'){
                        this.errorText = 'Debes ingresar el Punto de venta.';
                        document.querySelector("[attr-id='puntoVentaAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E15'){
                        this.errorText = 'El Punto de venta no puede ser superior a 99.';
                        document.querySelector("[attr-id='puntoVentaAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E16'){
                        this.errorText = 'El Punto de venta solo acepta caracteres númericos.';
                        document.querySelector("[attr-id='puntoVentaAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E17'){
                        this.errorText = 'Debes ingresar la Fecha de Inicio de actividades.';
                        document.querySelector("[attr-id='fechaInicioAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E18'){
                        this.errorText = 'La Fecha de Inicio de actividades no puede ser superior a la actual.';
                        document.querySelector("[attr-id='fechaInicioAfip']").classList.add("bad");
                    }		
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }	
                    return;
                }    
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;

            })
        },
        async getData(){  
            var payload = {
                action: 'get-afip-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userSelected,
                userMode: this.userMode,
                refContact: this.refContact
            }
            await axios.post('/index.php', payload)
            .then(result => {
                console.log(result)
                if(result.data.status == '200'){
                    this.razonSocialAfip = result.data.razonSocial;
                    this.domicilioAfip = result.data.domicilioFiscal;
                    this.condicionIvaAfip = result.data.condicionIva;
                    this.docTypeAfip = result.data.docTipo;
                    this.docAfip = result.data.cuit;
                    this.puntoVentaAfip = result.data.puntoVenta;
                    this.fechaInicioAfip = result.data.fechaInicio;
                    if(result.data.connectedOk == 1){
                        this.connectedOk = true;
                    }
                    if(this.condicionIva != 0){
                        this.disabledQuit = false;
                    }                  
                }
                if(this.userMode == '2'){
                    this.getDataProf();
                }else{
                    this.loadData = false;
                    this.disabledIvaType = false;
                }
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;

            })
        },
        async getDataProf(){  
            var payload = {
                action: 'get-afip-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                userMode: 1,
            }
            await axios.post('/index.php', payload)
            .then(result => {
                console.log(result)
                if(result.data.status == '200'){
                    if(result.data.connectedOk == 1){
                        this.connectedOk = true;
                        if(result.data.condicionIva == 6){
                            this.disabledTypeFac = true;
                            this.invoiceType = 11;
                        }else{
                            if(this.condicionIvaAfip == 1){
                                this.disabledTypeFac = true;
                                this.invoiceType = 1;   
                            }else{
                                this.disabledTypeFac = true;
                                this.invoiceType = 6;   
                            }
                            
                        }
                        this.condicionIvaProf = result.data.condicionIva;
                        this.loadData = false;
                    }else{
                        this.connectedOk = false;
                        this.loadData = false;
                    }                
                }else{
                    if(result.data.status == '400'){
                        if(result.data.error == 'E2'){
                            this.connectedOk = false;
                            this.loadData = false;
                        }
                    }
                }
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;

            })
        },
        async getPadron(){ 
            if(this.docAfip == ''){
                if(this.userMode == 2){
                    this.errorText = 'Debes ingresar el DNI o CUIT de la persona.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }
                }
                return
            }
            if(!this.connectedOk){
                return
            }
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            }); 
            //this.disabledIvaType = true;
            var payload = {
                action: 'get-afip-padron',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: localStorage.getItem('token'),
                dni: this.docAfip
            }
            await axios.post('/index.php', payload)
            .then(result => {     
                if(result.data.status == '200'){
                    if(result.data.datosPersona.tipoClave == 'CUIT'){
                        this.docTypeAfip = 80;
                        this.disabledIvaType = false;
                    }else if(result.data.datosPersona.tipoClave == 'CUIL'){
                        this.docTypeAfip = 86;
                        this.condicionIvaAfip = 5;
                    }else if(result.data.datosPersona.tipoClave == 'DNI'){
                        this.docTypeAfip = 96;
                        this.condicionIvaAfip = 5;
                    }
                    this.razonSocialAfip = result.data.datosPersona.nombre + ' ' + result.data.datosPersona.apellido;
                    if (result.data.datosPersona.domicilioFiscal != null){
                        this.domicilioAfip = result.data.datosPersona.domicilioFiscal.direccion + ' ' + result.data.datosPersona.domicilioFiscal.localidad + ' ' + result.data.datosPersona.domicilioFiscal.descripcionProvincia;
                    }
                    this.docAfip = result.data.datosPersona.idPersona;                    
                }else if(result.data.status == '300'){

                    this.errorText = 'El número de documento ingresado no es correcto.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }
                }else if(result.data.status == '400'){
                    if(this.connectedOk == true){
                        this.errorText = 'No se encontró ninguna persona con ese número de documento.';
                        this.toastBg = 'bg-danger';
                        this.toastColor = 'text-dark';
                        this.toastNumber++;
                        var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                        try{
                            document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                            var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                            var bsAlert = new Toast(myAlert);//inizialize it
                            bsAlert.show();//show it
                        }catch(e){

                        }
                    }else{
                        this.disabledIvaType = false;
                    }

                }
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;

            })
        }, 
        formatConcept(){
            this.concepto = this.concepto.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
        },
        async generateBill(){
            var elems = document.querySelectorAll(".bad");
            [].forEach.call(elems, function(el) {
                el.classList.remove("bad");
            });
            this.errorText = '';
            this.loading = true;
            this.disabled = true;
            
            var payload = {
                action: 'afip-billing',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userSelected,
                razonSocialCustomer: this.razonSocialAfip,
                domicilioFiscalCustomer: this.domicilioAfip,
                condicionIvaCustomer: this.condicionIvaAfip,
                docTipoCustomer: this.docTypeAfip,
                cuitCustomer: this.docAfip, 
                invoiceType: this.invoiceType,
                bookingId: this.bookingId,
                invoiceDetails: this.concepto.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim(),
                invoicePrice: this.billPrice,
                userMail: this.userMailAddress
            }
            await axios.post('/index.php', payload)
            .then(result => {
                this.loading = false; 
                if(result.data.status == '200'){
                    this.disabled = true;
                    this.$parent.closePopUp();
                    this.$parent.updateInvoice(this.bookingId, result.data.link);            
                }else if(result.data.status == '400'){
                    this.disabled = false;
                    if(result.data.error == 'E2'){
                        this.errorText = 'Debes ingresar el Apellido y Nombre o Razón Social.';
                        document.querySelector("[attr-id='razonSocialAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E3'){
                        this.errorText = 'El Apellido y Nombre o Razón Social no puede superar los 250 caracteres.';
                        document.querySelector("[attr-id='razonSocialAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E4'){
                        this.errorText = 'El Apellido y Nombre o Razón Social solo acepta caracteres alfanúmericos.';
                        document.querySelector("[attr-id='razonSocialAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E5'){
                        this.errorText = 'Debes ingresar el Domicilio comercial.';
                        document.querySelector("[attr-id='domicilioAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E6'){
                        this.errorText = 'El Domicilio comercial no puede superar los 250 caracteres.';
                        document.querySelector("[attr-id='domicilioAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E7'){
                        this.errorText = 'El Domicilio comercial solo acepta caracteres alfanúmericos.';
                        document.querySelector("[attr-id='domicilioAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E8'){
                        this.errorText = 'Debes seleccionar la Condición frente al IVA.';
                        document.querySelector("[attr-id='condicionIvaAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E9'){
                        this.errorText = 'Debes seleccionar el Tipo de documento.';
                        document.querySelector("[attr-id='docTypeAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E10'){
                        this.errorText = 'El Tipo de documento no puede ser CUIL con la Condición frente al IVA seleccionada.';
                        document.querySelector("[attr-id='docTypeAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E11'){
                        if(this.docTypeAfip == '80'){
                            this.errorText = 'Debes ingresar el CUIT.';
                        }else{
                            this.errorText = 'Debes ingresar el CUIL.';
                        }
                        document.querySelector("[attr-id='docAfip']").classList.add("bad");  
                    }else if(result.data.error == 'E12'){
                        if(this.docTypeAfip == '80'){
                            this.errorText = 'El CUIT debe estar formado por 11 números sin guiones.';
                        }else{
                            this.errorText = 'El CUIL debe estar formado por 11 números sin guiones.';
                        }
                        document.querySelector("[attr-id='docAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E13'){
                        if(this.docTypeAfip == '80'){
                            this.errorText = 'El CUIT debe estar formado por 11 números sin guiones.';
                        }else{
                            this.errorText = 'El CUIL debe estar formado por 11 números sin guiones.';
                        }
                        document.querySelector("[attr-id='docAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E14'){
                        this.errorText = 'Debes ingresar el concepto de venta.';
                        document.querySelector("[attr-id='billDetails']").classList.add("bad");  
                    }else if(result.data.error == 'E15'){
                        this.errorText = 'El concepto de venta no puede ser superior a 250 caracteres.';
                        document.querySelector("[attr-id='billDetails']").classList.add("bad"); 
                    }else if(result.data.error == 'E16'){
                        this.errorText = 'El concepto de venta solo acepta caracteres alfanúmericos.';
                        document.querySelector("[attr-id='puntoVentaAfip']").classList.add("bad"); 
                    }else if(result.data.error == 'E19'){
                        this.errorText = 'El mail no parece ser válido.';
                        document.querySelector("[attr-id='userMail']").classList.add("bad"); 
                    }else if(result.data.error == 'E20'){
                        this.errorText = 'El mail no parece ser válido.';
                        document.querySelector("[attr-id='userMail']").classList.add("bad"); 
                    }else if(result.data.error == 'E21'){
                        this.errorText = 'El mail no parece ser válido.';
                        document.querySelector("[attr-id='userMail']").classList.add("bad"); 
                    }else if(result.data.error == 'E200'){
                        this.errorText = result.data.sms; 
                    }		
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }	
                    return;
                }    
            })
            .catch(error => {
                this.loading = false;
                this.disabled = false;
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainerAfip').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;

            })
        },
        closePopUp(){
            this.$parent.closePopUp();
        },
        gotoAfip(){
            if(this.bill){
                this.$parent.closePopUp();
            }
            this.$router.push({ name: 'editAfipData'});
        },
        checkInvoiceType(){
            if(this.condicionIvaProf == 6){
                this.disabledTypeFac = true;
                this.invoiceType = 11;
            }else{
                if(this.condicionIvaAfip == 1){
                    this.disabledTypeFac = true;
                    this.invoiceType = 1;   
                }else{
                    this.disabledTypeFac = true;
                    this.invoiceType = 6;   
                }
                
            }
        }

    }
}
</script>
